import api from "../Utils/Instance"

const uploadImage=async Imagen=>
{
    try
    {
        const data = new FormData();
        data.append("file",Imagen);    
     
        try
        {
            const Peticion=await api.post(`/upload`,data);

            const { path } = Peticion.data;
            
            return { status:200, path };
        }
        catch(error)
        {
            return {
                status:400,
                data:error
            }
        }
    }
    catch(er)
    {
        console.log(er)
    }
}

export default uploadImage;